import {
  AfterViewInit,
  Component,
  Input,
  Type,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-modal",
  imports: [],
  templateUrl: "./modal.component.html",
  styleUrl: "./modal.component.scss",
})
export class ModalComponent implements AfterViewInit {
  @Input() title: string = "Modal Dinâmico";
  @Input() component!: Type<any>;
  @Input() data?: any;
  @Input() widthClass: string = "";
  @ViewChild("dynamicContainer", { read: ViewContainerRef })
  container!: ViewContainerRef;

  constructor(public activeModal: NgbActiveModal) {}

  ngAfterViewInit(): void {
    if (this.component) {
      const componentRef = this.container.createComponent(this.component);
      if (this.data) {
        Object.assign(componentRef.instance, this.data);
      }
    }
  }

  closeModal() {
    this.activeModal.close();
  }
}
